export const calendlyUrl = "https://calendly.com/yoann-chatsystem/presentation";
